<template>
    <!-- 商户进件 -->
    <div class="merchantList">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item>
                    <el-input size clearable v-model="searchForm.plan_no" placeholder="请输入方案编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="searchForm.plan_name" placeholder="请输入方案名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select size v-model="searchForm.status" clearable placeholder="请选择方案状态">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="启用" value="10"></el-option>
                        <el-option label="停用" value="20"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-model="rangeDate" type="datetimerange" range-separator="至"
                        start-placeholder="创建开始日期" end-placeholder="创建结束日期" value-format="yyyy-MM-dd"
                        @change="pickerChange"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
                        @click="onSearch(searchForm)">查询</el-button>
                    <el-button size="medium" type="primary" icon="el-icon-plus" style="font-size: 12px;"
                        @click="addLimits()">添加方案</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table :data="phaseRateList" size="mini" border style="width: 100%" v-loading="loading">
                <!-- 序号 -->
                <el-table-column header-align="center" align="center" fixed type="index" label="ID"
                    min-width="80"></el-table-column>
                <el-table-column header-align="center" align="center" prop="plan_no" label="方案编号" min-width="160"></el-table-column>
                <el-table-column header-align="center" align="center" prop="plan_name" label="方案名称" min-width="160"></el-table-column>
                <el-table-column header-align="center" align="center" prop="agent_no" label="涨价内容" min-width="120">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            style="padding:0;font-size:12px;text-decoration: underline;"
                            @click="seeClick(scope.row)"
                            >
                            查看
                            </el-button>
                    </template>  
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="create_time" label="创建时间" min-width="180"></el-table-column>
                <el-table-column header-align="center" align="center" prop="update_time" label="更新时间" min-width="180"></el-table-column>
                <el-table-column header-align="center" align="center" prop="status_text" label="状态" min-width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 10">启用</span>
                        <span v-else style="color: red;">停用</span>
                    </template>
                    
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="remark" label="备注" min-width="160"></el-table-column>
                <el-table-column header-align="center" align="center" fixed="right" label="操作" min-width="200">
                    <template slot-scope="scope">
                        <el-button @click="detail(scope.row)" type="text" size="small">详情</el-button>
                        <el-button @click="addAgent(scope.row)" type="text" size="small" v-if="scope.row.status == 10">添加代理</el-button>
                        <el-button @click="deactivate(scope.row)" type="text" size="small" v-if="scope.row.status == 10">停用</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :page-sizes="[10,20,50,100]" :current-page="currentPage" :page-size="pageSize" :total="total"
                layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </el-card>

        <el-dialog :title="changeFree" :visible.sync="dialogVisible" width="60%" :close-on-click-modal="false"
            :before-close="handleClose">

            <el-form :model="formInline" label-width="120px" :rules="rules" ref="ruleForm">
                <el-form-item label="方案名称" prop="plan_name" style="width: 90%;">
                    <el-input placeholder="请输入方案名称" style="width: 100%;" v-model="formInline.plan_name" :disabled="changeFree == '查看方案'"></el-input>
                </el-form-item>
                <el-form-item label="涨价规则" prop="plan_rule" style="width: 90%;">
                    <el-form label-position="top" label-width="80px">
                            <el-form-item>
                                <el-table :data="plan_rule" border max-height="456px">
                                    <el-table-column
                                        header-align="center"
                                        align="center"
                                        min-width="160"
                                        prop="is_default"
                                        label="涨价标准"
                                    >
                                        <template slot-scope="scope">
                                            <span>商户自绑机日起</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        header-align="center"
                                        align="center"
                                        min-width="300"
                                        prop=""
                                        label="涨价天数区间"
                                    >
                                        <template slot-scope="scope">
                                            <div style="display: flex;align-items: center; justify-content: center;">
                                                <el-input maxlength="5"
                                                     :disabled="changeFree == '查看方案'"
                                                    v-model="scope.row.day_from"
                                                    placeholder="开始天数"
                                                ></el-input> 
                                                <span style="text-align: center;width: 60px;font-size: 20px;"> ~ </span>
                                                <el-input maxlength="5"
                                                     :disabled="changeFree == '查看方案'"
                                                    v-model="scope.row.day_end"
                                                    placeholder="结束天数"
                                                ></el-input>
                                            </div>
                                            
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        header-align="center"
                                        align="center"
                                        min-width="280"
                                        prop="up_type"
                                        label="涨价类型"
                                    >
                                        <template slot-scope="scope">
                                            <span style="margin-right: 10px;">代理商结算价:</span>
                                            <el-select :disabled="changeFree == '查看方案'" style="width: 140px;" size v-model="scope.row.up_type" clearable placeholder="请选择涨价类型">
                                                <el-option label="上涨" :value="1"></el-option>
                                                <el-option label="涨至" :value="2"></el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        header-align="center"
                                        align="center"
                                        min-width="200"
                                        prop="up_value"
                                        label="涨价幅度"
                                    >
                                        <template slot-scope="scope">
                                            <el-input  maxlength="7"
                                            style="width: 140px;"
                                                 :disabled="changeFree == '查看方案'"
                                                v-model="scope.row.up_value"
                                                placeholder="请输入涨价幅度"
                                            ></el-input>
                                            <span style="margin-left: 10px;">%</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        header-align="center"
                                        align="center"
                                        min-width="120"
                                        label="操作"
                                    >
                                        <template slot-scope="scope">
                                            <el-button
                                                 v-if="plan_rule.length > 1 && changeFree != '查看方案'"
                                                @click="handleDel(scope.row,scope.$index)"
                                                type="text"
                                                size="small"
                                            >删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-form-item>
                            <el-form-item >
                                <el-button
                                    type="text"
                                    icon="el-icon-plus"
                                    @click="handleAdd"
                                    v-if="plan_rule.length < 3 && (changeFree != '查看方案')"
                                >增加模板</el-button>
                            </el-form-item>

                    </el-form>
                    
                </el-form-item>
                <el-form-item label="备注(选填)" prop="remark" style="width: 90%;">
                    <el-input type="textarea" placeholder="请输入备注" style="width: 100%;" v-model="formInline.remark" :disabled="changeFree == '查看方案'" maxlength="100"></el-input>
                </el-form-item>
             </el-form>    

            <span slot="footer" class="dialog-footer" v-if="changeFree != '查看方案'">
                <el-button @click="handleClose()">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="添加代理" :visible.sync="dialogVisibleAgent" width="60%" :close-on-click-modal="false"
            :before-close="handleCloseAgent">
        
            <el-form :model="formInlineAgent" label-width="120px" :rules="rules" ref="ruleForm">
                
                <el-form-item label="代理商账号:"  prop="user_id" style="width: 90%;">
                    <el-select @change="agentSelClick" style="width: 100%;"  filterable v-model="formInlineAgent.user_id" placeholder="请选择代理商账号">
                      <el-option v-for="(item,index) in agentList" :key="item.phone" :label="item.nickname + '(' + item.phone  + ')'" :value="item.id"></el-option>
                    </el-select>            
                 </el-form-item>
                 <el-form-item label="代理商名称:" prop="user_name" style="width: 90%;">
                     <span>{{formInlineAgent.user_name}}</span>
                 </el-form-item>
                 <el-form-item label="选择政策:"  prop="brand_id" style="width: 90%;">
                    <el-select style="width: 100%;" multiple filterable v-model="formInlineAgent.brand_id" placeholder="请选择政策">
                        <el-option v-for="(item,index) in brandList" :key="item.name" :label="item.name" :value="item.id"></el-option>
                    </el-select>                   
                  </el-form-item>
             </el-form>    
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCloseAgent()">取 消</el-button>
                <el-button type="primary" @click="agentSave()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "phaseAddRate",
        data() {
            return {
                changeFree:'添加方案',
                searchForm: {
                    plan_name:'',
                    plan_no:this.$route.query.plan_no,
                    status: '',
                    start_time: '',
                    end_time: '',
                    page:1,
                    limit:10
                },
                rangeDate: '',
                id: '',
                phaseRateList: [],
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 0, //总数
                loading: true,
                level: sessionStorage.getItem('level'),
                agentList:[],
                brandList: [],
                //添加方案
                dialogVisible: false,
                //添加代理商
                dialogVisibleAgent: false,
                formInlineAgent: {
                    plan_id: '',
                    user_id: '',
                    brand_id: '',
                    user_name:'',  
                },
                formInline: {
                    remark: '',
                    plan_name: '',
                    plan_rule: []
                },
                plan_rule:[{
                      day_from:'',
                      day_end:'',
                      up_type:1,
                      up_value:''
                }],
                rules: {
                    plan_name: [{
                        required: true,
                        message: '请输入方案名称',
                        trigger: 'blur'
                    }],
                    brand_id: [{
                        required: true,
                        message: '请选择政策',
                        trigger: 'change'
                    }],
                    user_id: [{
                        required: true,
                        message: '请选择代理商账号',
                        trigger: 'change'
                    }],

                }
            }
        },
        created() {

        },
        mounted() {
            this.$api.post('settle_rate/userList', {}, res => { //获取代理商
                if (res.code == 0) {
                    this.agentList = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
            this.getData(this.searchForm)
        },
        methods: {
            agentSelClick(e){
                console.log(e);
                for (let item of this.agentList) {
                    if (item.id == e) {
                        this.formInlineAgent.user_name = item.nickname
                        this.getBrandList(item.id)
                    }
                }
            },
            getBrandList(id){
                this.$api.post('settle_rate/userBrand', {'user_id':id}, res => { //获取代理商
                console.log(res);
                    if (res.code == 0) {
                        this.brandList = res.data;
                    } else {
                        this.$message.error(res.msg);
                    }
                });
                
            },
            handleAdd(){
                let item = {
                      day_from:'',
                      day_end:'',
                      up_type:1,
                      up_value:''
                }
                this.plan_rule.push(item)
                
            },
            handleDel(row, index) { //删除
                this.$confirm('确定删除该模板吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.plan_rule.splice(index, 1);
                }).catch(() => {
            
                })
            },
            onSearch(searchFrom) {
                
                this.currentPage = 1;
                searchFrom.page = 1;
                this.getData(searchFrom);
            },
            getData(params) { //获取数据
            console.log(params);
                this.loading = true;
                this.$api.post("settle_rate/planList", params, res => {
                    let data = res.data;
                    this.total = data.count; //总数
                    this.phaseRateList = res.data.list;
                    //渲染结束后取消加载
                    this.loading = false;
                })
            },
            handleCurrentChange(page) { //当前选中页
                this.currentPage = page;
                this.searchForm.page = page;
                this.searchForm.limit = this.pageSize;
                this.getData(this.searchForm);
            },
            handleSizeChange(limit) { //条数
                this.currentPage = 1;
                this.pageSize = limit;
                this.searchForm.page = 1;
                this.searchForm.limit = limit;
                this.getData(this.searchForm);
            },
            pickerChange(DateArr) { //时间选择器
                this.searchForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
                this.searchForm.end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
            },

            //新增调价权限
            addLimits() {
                this.changeFree ='添加方案'
                this.dialogVisible = true;
            },
            //关闭弹框
            handleClose() {
                this.dialogVisible = false;
                this.$refs['ruleForm'].resetFields();
                this.formInline = {
                    plan_name: "",
                    remark: '',
                    plan_rule:[]
                }
                this.plan_rule =[{
                      day_from:'',
                      day_end:'',
                      up_type:1,
                      up_value:''
                }]
            },
            handleCloseAgent() {
                this.dialogVisibleAgent = false;
                this.$refs['ruleForm'].resetFields();
                this.formInlineAgent = {
                    plan_id:'',
                    user_id:'',
                    brand_id:'',
                    user_name:''
                }
                
            },
            
            //保存
            save() {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        for (let item of this.plan_rule) {
                            if (item.day_end == '' || item.day_from == '' || item.up_value == '') {
                                this.$message({
                                    type: 'error',
                                    message: '请完整输入涨价规则!'
                                });
                                return
                            }
                        }
                        this.formInline.plan_rule = this.plan_rule
                        this.$api.post("settle_rate/addPlan", this.formInline, res => {
                            if (res.code == 0) {
                                this.$message.success(res.msg);
                                this.handleClose();
                                this.getData({
                                    page: 1,
                                    limit: 10
                                })
                            } else {
                                this.$message.error(res.msg);
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            agentSave() {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.$api.post("settle_rate/saveSettleRateUpPlanUser", this.formInlineAgent, res => {
                            if (res.code == 0) {
                                this.$message.success(res.msg);
                                this.handleCloseAgent();
                            } else {
                                this.$message.error(res.msg);
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            seeClick(row){
                this.changeFree ='查看方案'
                this.$api.post("settle_rate/planInfo", {plan_id:row.id}, res => {
                    if (res.code == 0) {
                        this.formInline = res.data;
                        this.plan_rule = this.formInline.rule
                        this.dialogVisible = true;
                    }
                })
            },
            detail(row){
                this.$router.push({ path: '/phaseRateDetail', query: { id: row.id,status: row.status } });
            },
            //添加代理
            addAgent(row){
                this.formInlineAgent.plan_id = row.id
                this.dialogVisibleAgent = true
                this.$api.post('settle_rate/userList', {}, res => { //获取代理商
                    if (res.code == 0) {
                        this.agentList = res.data;
                    } else {
                        this.$message.error(res.msg);
                    }
                }); 
            },
            //停用
            deactivate(row) {
                this.$confirm("确定停用方案,不可恢复,请谨慎操作?", '提 示', {
                    type: 'warning',
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确 定',
                    cancelButtonText: '取 消'
                }).then(() => {
                    this.$api.post("settle_rate/planForbidden", {plan_id:row.id}, res => {
                        if (res.code == 0) {
                            this.$message.success(res.msg);
                            this.getData({
                                page: 1,
                                limit: 10
                            })
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                }).catch(() => {})
            }
        }
    }
</script>

<style scoped lang="scss">
    .el-form-item {
        margin-bottom: 20px;
    }

    .el-select,
    .el-input {
        width: 180px;
        font-size: 12px;
    }
</style>